module.exports = __webpack_public_path__ + "media/images/bg-hero-1e5e558f2ed733e8e4ce26724bc6c34b.png";